import genNewRichText from './genNewRichText';
const getUpdatedAlignment = (ALIGNMENT_OPTIONS, alignment, currentRichTextImageAsDomElement, currentRichTextImage) => {
  let newStyle = 'max-width: 100%; max-height: 100%;';
  switch (alignment) {
    case ALIGNMENT_OPTIONS.right:
      newStyle += ' float:right;';
      break;
    case ALIGNMENT_OPTIONS.center:
      newStyle += ' display:block; margin-left:auto; margin-right:auto;';
      break;
    case ALIGNMENT_OPTIONS.left:
    default:
      break;
  }
  return genNewRichText(currentRichTextImageAsDomElement, currentRichTextImage, 'style', newStyle);
};
export default getUpdatedAlignment;